import './ui/styles.css';
import { initApp } from './ui/app';

initApp(document.getElementById('app') as HTMLElement);
